import React from "react";
import styled from "styled-components";

const Footer = () => {
  const currentYear = (new Date()).getFullYear(); 
  return (
    <Wrapper>
      <div className="section f-section">
      <div className="f-container">
        <div className="f-credits">
          <p>
           ©️ {currentYear} All rights reserved | designed with <span className="text-white">❤️</span> by Mitesh Koshiya
          </p>
        </div>
      </div>
    </div>
    </Wrapper>
  );
}
export default Footer;

const Wrapper = styled.footer`
 position: relative;
 width: 100vw;
 height: auto;
 bottom: 0;
.f-section {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.bg.primary};
    padding: 10px 0 10px 0;
    z-index: 1;
    font-size: 0.7rem;
    p {
        font-size: 0.8rem;
    }
    .f-credits {
        width: 100%;
        height: 100%;
        p {
            margin: 0;
            padding-bottom: 2px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
}
@media (max-width: 1197px) {
    .f-section {
        z-index: 3;
        margin-top: 100px;
    }
}
@media (max-width: 560px) {
    .f-section {
        z-index: 3;
        margin-top: 70px;
    }
   .f-section .f-credits p{
    font-size: 0.71rem;
    text-align: center;
   }
}
`
